// ============================================================================
// BonBoZ: mẫu trả lời NHIỀU TIN + biến xưng hô — dùng chung cho mọi đường chèn
// mẫu (bảng mẫu nút ≡, danh sách gõ "/") và cho đường gửi (ReplyBox).
//
// NHIỀU TIN (issue #115, chốt "gửi thành từng bong bóng"): ô soạn chỉ có MỘT ô
// chữ, nên các tin nằm chung trong đó, ngăn bằng một dòng VẠCH. Lúc gửi thì cắt
// tại vạch và gửi lần lượt. Để vạch hiện ngay trong ô soạn chứ không giấu các
// tin sau vào đâu: người trực vẫn sửa được từng tin trước khi gửi, xoá vạch là
// gộp hai tin, gõ thêm vạch là tách.
//
// XƯNG HÔ: cú pháp Pancake `#SEX{nam|nữ|chưa rõ}`, ví dụ `#SEX{anh|chị|anh/chị}`.
// Đổi LÚC CHÈN theo giới tính khách, không đổi lúc nhập — cùng một mẫu dùng cho
// cả khách nam lẫn nữ.
// ============================================================================

export const VACH = '───';

// Dong chi co vach (cho phep khoang trang quanh), dung rieng mot dong.
const DONG_VACH = /\n[ \t]*───[ \t]*(?:\n|$)/;

/** [tin1, tin2, ...] -> chuỗi để chèn vào ô soạn. */
export const noiTin = tin =>
  tin
    .map(t => (t || '').trim())
    .filter(Boolean)
    .join(`\n\n${VACH}\n\n`);

/**
 * Chuỗi trong ô soạn -> các bong bóng sẽ gửi. Không có vạch thì trả về đúng một
 * phần tử — tin thường đi y như cũ.
 */
export const tachBongBong = noiDung =>
  `\n${noiDung || ''}\n`
    .split(DONG_VACH)
    .map(t => t.trim())
    .filter(Boolean);

/**
 * Giới tính khách -> 'nam' | 'nu' | ''.
 *
 * Nhận CẢ HAI kiểu giá trị đang có trong `custom_attributes.kh_gioi_tinh`: ô
 * "Giới tính" ở cột Thông tin ghi "Nam"/"Nữ" (hoSoKhach.js), còn CRM/chatbot
 * ghi "male"/"female" (EpointCrmPanel.vue đọc kiểu này). Bắt một kiểu là nửa
 * số khách xưng hô sai mà không ai thấy lỗi.
 */
export const gioiTinhKhach = contact => {
  const g = String(contact?.custom_attributes?.kh_gioi_tinh || '')
    .trim()
    .toLowerCase();
  if (['nam', 'male'].includes(g)) return 'nam';
  if (['nữ', 'nu', 'female'].includes(g)) return 'nu';
  return '';
};

/**
 * `#SEX{anh|chị|anh/chị}` -> "anh" / "chị" / "anh/chị" theo giới tính.
 * Thiếu vế "chưa rõ" (`#SEX{anh|chị}`) thì ghép "anh/chị" — không bao giờ để
 * khách nhận nguyên chữ `#SEX{...}`.
 */
export const thayXungHo = (noiDung, gioiTinh) =>
  (noiDung || '').replace(/#SEX\{([^}]*)\}/g, (_, bo) => {
    const [nam = '', nu = '', chuaRo] = bo.split('|').map(x => x.trim());
    if (gioiTinh === 'nam') return nam || nu;
    if (gioiTinh === 'nu') return nu || nam;
    return chuaRo || [nam, nu].filter(Boolean).join('/');
  });

// Bien ten kieu Pancake: `#{FULL_NAME}` (ten khach), `#{STAFF_DETAILS}` (ten
// nhan vien dang truc). Thieu ten thi bo ca khoang trang dung truoc bien:
// "Chào chị #{FULL_NAME}, ..." -> "Chào chị, ..." chu khong phai "Chào chị , ...".
const thayTen = (noiDung, bien, ten) =>
  noiDung.replace(new RegExp(`( ?)#\\{${bien}\\}`, 'g'), (_, cach) =>
    ten ? `${cach}${ten}` : ''
  );

/**
 * Đổi mọi biến Pancake trong một đoạn chữ theo ngữ cảnh lúc chèn:
 * `{ gioiTinh, tenKhach, tenNhanVien }`. Biến lạ khác để nguyên cho người trực
 * nhìn thấy mà sửa, thay vì âm thầm xoá.
 */
export const thayBien = (noiDung, nguCanh = {}) =>
  thayTen(
    thayTen(
      thayXungHo(noiDung, nguCanh.gioiTinh),
      'FULL_NAME',
      (nguCanh.tenKhach || '').trim()
    ),
    'STAFF_DETAILS',
    (nguCanh.tenNhanVien || '').trim()
  );

/** Ngữ cảnh chèn mẫu từ khách đang mở và nhân viên đang đăng nhập. */
export const nguCanhChen = (contact, nhanVien) => ({
  gioiTinh: gioiTinhKhach(contact),
  tenKhach: contact?.name,
  tenNhanVien: nhanVien?.available_name || nhanVien?.name,
});

/** Mẫu trả lời -> chuỗi chèn vào ô soạn: đủ các tin, đã đổi biến. */
export const noiDungMau = (mau, nguCanh) =>
  thayBien(noiTin([mau?.content, ...(mau?.tin_them || [])]), nguCanh);
